export const LIVE_VARIANT = 'live';
export const BASE_VARIANT = 'base';
export const PRIMARY_GRAY_VARIANT = 'primaryGray';
export const LIVESCORE_FULL_TIME_VARIANT = 'livescoreFullTime';
